module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// /Users/bvzk/Local Sites/xpansiv/app/public/wp-content/themes/xpansiv-wordpress/node_modules/axios/lib/env/data.js
// module id = 22
// module chunks = 0